import React from 'react';

export type BadgeTone = 'success' | 'info' | 'warning' | 'danger' | 'muted';

export function Badge({ tone = 'muted', children }: { tone?: BadgeTone; children: React.ReactNode }) {
  return <span className={`badge badge-${tone}`}>{children}</span>;
}

export function rsvpTone(rsvp: string): BadgeTone {
  switch (rsvp) {
    case 'ACCEPTED':
      return 'success';
    case 'DECLINED':
      return 'danger';
    case 'TENTATIVE':
      return 'warning';
    case 'DELEGATED':
      return 'info';
    default:
      return 'muted';
  }
}

export function rsvpLabel(rsvp: string): string {
  switch (rsvp) {
    case 'ACCEPTED':
      return 'Angenommen';
    case 'DECLINED':
      return 'Abgelehnt';
    case 'TENTATIVE':
      return 'Vielleicht';
    case 'DELEGATED':
      return 'Delegiert';
    default:
      return 'Keine Antwort';
  }
}

export function deliveryTone(s: string): BadgeTone {
  switch (s) {
    case 'SENT':
      return 'success';
    case 'FAILED':
      return 'danger';
    case 'PENDING':
      return 'info';
    default:
      return 'muted';
  }
}
